export function generateThumbnail(file: File): Promise<string> {
  return new Promise((resolve) => {
    const video = document.createElement('video');
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const objectURL = URL.createObjectURL(file);

    video.src = objectURL;
    video.onloadedmetadata = function () {
      video.currentTime = Math.floor(video.duration / 2);
    };
    video.onseeked = function () {
      if (context) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL('image/jpeg');
        URL.revokeObjectURL(objectURL);
        resolve(dataURL);
      }
    };
  });
}
